<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update_prevent(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
        }
    },
    watch: {
        async 'single_object.shift_id' (val)
        {
            let found_shift = this.array_options.shift_id.find(shift => val === shift.id);
            if(found_shift)
            {
                this.single_object.time_start = found_shift.start_time
                this.single_object.time_end = found_shift.end_time
            }
        }

    } ,
    
    methods:{

        form_submit_update_prevent(id, index)
        {
            if(this.single_object.length === '' || this.single_object.length === 0)
            {
                this.notyf.error("Length cannot be empty or zero")
                return false
            }
            this.form_submit_update(id, index)
        },

    },

    mounted(){

    }
    
}
</script>